/* SMAEL — home: aparecer ao rolar + contadores. Sem dependências; falha segura (tudo aparece se algo der errado). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function contar(el) {
    var alvo = parseFloat(el.getAttribute('data-smh-count'));
    if (isNaN(alvo) || el.getAttribute('data-smh-done')) return;
    el.setAttribute('data-smh-done', '1');
    var dur = reduce ? 600 : 1300, t0 = null;
    function passo(t) {
      if (t0 === null) t0 = t;
      var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(alvo * e);
      if (p < 1) requestAnimationFrame(passo); else el.textContent = String(alvo);
    }
    el.textContent = '0';
    requestAnimationFrame(passo);
  }

  function revelar(el) {
    el.classList.add('is-in');
    var c = el.querySelectorAll ? el.querySelectorAll('[data-smh-count]') : [];
    for (var i = 0; i < c.length; i++) contar(c[i]);
  }

  function iniciar() {
    var els = [].slice.call(document.querySelectorAll('.smh-reveal:not(.is-in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(revelar); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { revelar(en.target); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
    setTimeout(function () { els.forEach(function (e) { if (!e.classList.contains('is-in')) revelar(e); }); }, 6000);   // rede de segurança
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
